import "../build/ckeditor" // Needed for CKEditor styling
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import SanitizedHtml from "shared/sanitized-html"

/**
 * @typedef {object} CkeditorPresentationProps
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} html
 */

/** @typedef {object} CkeditorPresentationState */

/**
 * @extends {ShapeComponent<CkeditorPresentationProps, CkeditorPresentationState>}
 */
class CkeditorPresentation extends ShapeComponent {
  static propTypes = {
    className: PropTypes.string,
    html: PropTypes.string.isRequired
  }

  render() {
    const {children, className, html, ...restProps} = this.props

    if (children && children.length > 0) {
      throw new Error("Children are not supported")
    }

    return (
      <SanitizedHtml
        className={classNames("components--ckeditor--presentation", className)}
        html={this.actualHtml()}
        {...restProps}
      />
    )
  }

  actualHtml() {
    const {html} = this.p

    if (html) {
      return `<div class='ck-content'>${html}</div>`
    } else {
      return ""
    }
  }
}

export default memo(shapeComponent(CkeditorPresentation))
